import React, { useEffect, useRef, useState, Fragment } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getReportLink, getReportMenu, triggerNavFocus } from '../../actions/Page/PageAction';
import { getCohorts, getCohortsOrganizations } from '../../actions/Cohort/CohortAction';
import CreateCohort from '../Cohort/CreateCohort';
import ReactGA from 'react-ga';
import Api from '../../Api';
import Constants from '../../Constants';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Button } from '../Common';
import withNavigate from '../HOC/navigate';
import { ASSOCIATION_USER, REPORT_USER, SPECIALTY_USER } from '../../actionTypes/Users/UserActionType';
import gtmService from '../../services/GTMService';

const Reports = ({
  sideNavToggle,
  reportLink,
  linkName,
  userPersonated,
  cohorts,
  reportLinkObj,
  casDetails,
  workSheetName,
  navigate,
  getReportLink,
  getCohorts,
  getCohortsOrganizations,
  triggerNavFocus,
  reportMenus,
  institutionDetails,
  loggedUserDetails,
}) => {
  const [actionsToggle, setActionsToggle] = useState(true);
  const [dropdown, setDropdown] = useState(false);
  const [dropdownCohort, setDropdownCohort] = useState(false);
  const [setRight, setSetRight] = useState(0);
  const [casORGID1, setcasORGID1] = useState('');

  const tableauRef = useRef();
  const tableauReportRef = useRef();
  const { reportMenus: tempRPMenu } = useSelector((state) => state.Page);
  const exportData = (funcName, workSheetName = '') => {
    setDropdown(false);
    if (['showExportDataDialog', 'showExportCrossTabDialog'].includes(funcName) && workSheetName) {
      tableauRef.current[funcName](workSheetName);
    } else {
      tableauRef.current[funcName]();
    }

    // GTM Export tracking
    const exportFormat = funcName.includes('PDF') ? 'PDF' : 
                        funcName.includes('Image') ? 'Image' :
                        funcName.includes('CrossTab') ? 'CrossTab' : 'Data';
    
    gtmService.trackReportExport(exportFormat, linkName, {
      worksheet_name: workSheetName,
      export_function: funcName,
      report_url: reportLink,
      user_role: loggedUserDetails.userRole,
      cas_id: casDetails.casId
    });
  };

  const revertFilters = () => {
    setDropdown(false);
    tableauRef.current.revertAllAsync();
    tableauInit();
  };

  const tableauInit = () => {
    if (!reportLinkObj.filterByCohort && reportLink) {
      const api = new Api();
      api.getData(Constants.apiUrls.reportTicket).then((resp) => {
        const url = reportLink;
        const length = url.indexOf('views');
        let newUrl = url.slice(0, length) + 'trusted/' + resp.ticket + '/' + url.slice(length);
        const containerDiv = document.getElementById('tableau-reports-Link');
        if (!containerDiv) return;

        const child = document.getElementById('renderReports');
        if (child) containerDiv.removeChild(child);

        const renderReportsElement = document.createElement('div');
        renderReportsElement.setAttribute('id', 'renderReports');
        containerDiv.appendChild(renderReportsElement);

        const options = {
          onFirstInteractive: () => {
            const iframe = containerDiv.querySelector('iframe');
            if (iframe) {
              iframe.setAttribute('title', linkName);
              iframe.setAttribute('aria-label', linkName);
              iframe.onload = () => window.scrollTo(0, 0);
            }
          },
        };
        if (
          (loggedUserDetails.userRole == REPORT_USER ||
            ![ASSOCIATION_USER, SPECIALTY_USER].includes(loggedUserDetails.userRole)) &&
          casDetails?.casId &&
          reportMenus.dashboard?.reportURL &&
          !url.includes('Cohort_Report')
        ) {
          let tempURL = newUrl.split('&casid=')[0];
          const result = institutionDetails.casOrgs
            .filter((org) => org.casId === casDetails.casId)
            .map((org) => ({
              ...org,
              clients: org.clients.filter((client) => client.id === casDetails.clientId),
            }))
            .filter((org) => org.clients.length > 0);

          tempURL += `&casid=${casDetails.casId}&CAS_OrgID1=${tempRPMenu.dashboard.reportURL.split('&CAS_OrgID1=')[1]}`;
          tableauRef.current = new window.tableau.Viz(renderReportsElement, tempURL, options);
        } else if ([ASSOCIATION_USER].includes(loggedUserDetails.userRole)) {
          let tempURL = newUrl.split('&casuniqueid=')[0];
          const casuniqueid = tempRPMenu.dashboard.reportURL.split('&casuniqueid=')[1];
          tempURL = tempURL + `&casuniqueid=${casuniqueid}`;

          if (tableauRef.current) {
            tableauRef.current.dispose();
          }
          tableauRef.current = new window.tableau.Viz(renderReportsElement, tempURL, options);
        } else {
          /** Fixing NF-77139, in following if block remove old casid and add currect selected casid to get report */
          if (newUrl.includes('Cohort_Report_UD/')) {
            let tempUrlCasId = new URLSearchParams(newUrl).get('casid');
            newUrl = newUrl.replace(`casid=${tempUrlCasId}`, `casid=${casDetails.casId}`);
          }
          if (tableauRef.current) {
            tableauRef.current.dispose();
          }
          tableauRef.current = new window.tableau.Viz(renderReportsElement, newUrl, options);
        }
        options.onFirstInteractive();

        ReactGA.event({
          category: 'Reports',
          action: 'Report View',
          label: linkName,
        });

        // GTM Report View tracking
        gtmService.trackReportGeneration('tableau_report', {
          report_name: linkName,
          report_url: url,
          user_role: loggedUserDetails.userRole,
          cas_id: casDetails.casId,
          client_id: casDetails.clientId,
          is_cohort_filtered: reportLinkObj.filterByCohort,
          timestamp: new Date().toISOString()
        });
      });
    }
  };

  const toggleTray = () => {
    const rightValue = !actionsToggle ? 0 : `-${document.getElementById('sideTray').offsetWidth - 20}px`;
    setActionsToggle(!actionsToggle);
    setDropdown(false);
    setDropdownCohort(false);
    setSetRight(rightValue);
  };

  const toggleDropdown = (state, type) => {
    if (type === 'cohort') {
      setDropdownCohort(!state);
      setDropdown(false);
    } else {
      setDropdown(!state);
      setDropdownCohort(false);
    }
  };

  const refreshSavedCohort = (cohort) => {
    toggleDropdown(dropdownCohort, 'cohort');
    const api = new Api();
    const url = `${Constants.apiUrls.cohorts}/${cohort.id}`;
    api.getData(url).then((resp) => {
      const data = {
        name: cohort.name,
        clientIdsSelected: resp.clientIdsSelected,
      };
      const myInit = { body: data };
      const saveUrl = Constants.apiUrls.saveCohort + 0;
      api.postData(saveUrl, myInit).then((resp) => {
        const updatedReport = {
          ...reportLinkObj,
          reportUrl: reportLinkObj.originalUrl + resp.cohortUrlParameters,
          filterByCohort: false,
          passByUD: true,
          cohortObj: data,
          saved: false,
        };
        getReportLink(updatedReport);
      });
    });
  };

  const saveCohort = () => {
    const updatedReport = {
      ...reportLinkObj,
      filterByCohort: true,
      reportUrl: reportLinkObj.originalUrl,
    };
    getReportLink(updatedReport);
  };

  const renderCohorts = () => {
    const checkCond = reportLinkObj.cohortObj?.name;

    return cohorts.map((cohort, index) => (
      <DropdownItem
        key={index}
        className={checkCond === cohort.name ? 'active' : ''}
        onClick={() => refreshSavedCohort(cohort)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            refreshSavedCohort(cohort);
          }
        }}>
        {cohort.name}
      </DropdownItem>
    ));
  };

  const renderDownloadAsOptions = (hideExport) => {
    let downloadAs = [
      { title: 'PDF', params: ['showExportPDFDialog'] },
      { title: 'Cross Tab', params: ['showExportCrossTabDialog', workSheetName] },
      { title: 'Data', params: ['showExportDataDialog', workSheetName] },
      { title: 'Image', params: ['showExportImageDialog'] },
    ];

    if (hideExport) {
      downloadAs = downloadAs.filter((opt) => !['Cross Tab', 'Data'].includes(opt.title));
    }

    return downloadAs.map((opt) => (
      <DropdownItem
        key={opt.title}
        onClick={() => exportData(...opt.params)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            exportData(...opt.params);
          }
        }}>
        {opt.title}
      </DropdownItem>
    ));
  };
  useEffect(() => {
    getReportMenu(casDetails.clientId);
  }, [casDetails.clientId]);

  useEffect(() => {
    console.log('cohorts change..');
  }, [cohorts]);

  useEffect(() => {
    tableauInit();
    if (!reportLinkObj.filterByCohort) {
      getCohorts(casDetails.casId);
    }
    getCohortsOrganizations(casDetails.casId);
    if (tableauReportRef.current) tableauReportRef.current.focus();
  }, []);

  useEffect(() => {
    tableauInit();
    setSetRight(0);
    if (tableauReportRef.current) tableauReportRef.current.focus();
  }, [reportLink, reportLinkObj.saved, casDetails.clientId, casDetails.casId]);

  useEffect(() => {
    if (Object.keys(tempRPMenu.dashboard).length) setcasORGID1(tempRPMenu.dashboard.reportURL.split('&CAS_OrgID1=')[1]);
    tableauInit();
  }, [reportMenus]);
  const { hideDownload, hideExport, filterByCohort, passByUD, saved } = reportLinkObj;
  const nameClass = userPersonated ? 'right-sideNav-fixed top-more ' : 'right-sideNav-fixed ';
  const classZIndex = dropdown ? 'right-side-nav-open increase-z-index' : 'right-side-nav-open';
  const closeTray = hideDownload ? 'right-side-nav-download-close' : 'right-side-nav-close';

  return (
    <Fragment>
      <div className="reports pTop-20">
        {!filterByCohort && (
          <div>
            <h1 id="app_page_title" className="hide-by-pos">
              Reports Page
            </h1>
            <div
              className="tableau-report iframe-container"
              id="tableau-reports-Link"
              ref={tableauReportRef}
              tabIndex="0"
              onKeyDown={(e) => {
                if (e.shiftKey && e.key === 'Tab' && !sideNavToggle) {
                  e.preventDefault();
                  triggerNavFocus();
                }
              }}>
              <div id="renderReports"></div>
            </div>
            <nav
              aria-label="export data"
              className={nameClass + (actionsToggle ? classZIndex : closeTray)}
              id="sideTray"
              style={{ right: setRight }}>
              <ul className="verticle-middle cohort-right-menu-container">
                <li className="mRight-15">
                  <button
                    className="toggle-icon"
                    aria-label={`export data toggle menu ${actionsToggle ? 'expanded' : 'collapsed'}`}
                    role="switch"
                    aria-checked={actionsToggle}
                    onClick={toggleTray}>
                    <i className={`far ${actionsToggle ? 'fa-angle-right' : 'fa-angle-left'}`} />
                  </button>
                </li>
                {passByUD && (
                  <>
                    {saved && (
                      <li className="mRight-5">
                        <Button
                          isNew
                          shrank
                          size="micro"
                          appearance="secondary"
                          icon="filter fa"
                          text="Save Cohort"
                          onClick={saveCohort}
                          id="button-report-cohort-save"
                        />
                      </li>
                    )}
                    {cohorts?.length > 0 && (
                      <li className="mRight-5">
                        <Dropdown
                          isOpen={dropdownCohort}
                          className="select-cohort"
                          toggle={() => toggleDropdown(dropdownCohort, 'cohort')}>
                          <DropdownToggle className="btn-menu">
                            Select Cohort <i className="fa fa-caret-down mLeft-5" />
                          </DropdownToggle>
                          <DropdownMenu>{renderCohorts()}</DropdownMenu>
                        </Dropdown>
                      </li>
                    )}
                    <li className="mRight-5">
                      <Button
                        isNew
                        shrank
                        size="micro"
                        appearance="secondary"
                        icon="cogs fa"
                        text="Manage Cohorts"
                        onClick={() => navigate('/manageCohort')}
                        id="button-report-cohort-manage"
                      />
                    </li>
                  </>
                )}
                {!hideDownload && (
                  <li className="mRight-5">
                    <Dropdown
                      isOpen={dropdown}
                      className="download-as"
                      toggle={() => toggleDropdown(dropdown, 'reportActions')}>
                      <DropdownToggle className="btn-menu">
                        <i className="fa fa-download mRight-5" />
                        Download As
                        <i className="fa fa-caret-down mLeft-5" />
                      </DropdownToggle>
                      <DropdownMenu>{renderDownloadAsOptions(hideExport)}</DropdownMenu>
                    </Dropdown>
                  </li>
                )}
                <li>
                  <Button
                    isNew
                    shrank
                    size="micro"
                    appearance="secondary"
                    icon="filter fa"
                    text="Clear Filters"
                    id="button-report-filters-clear"
                    onClick={revertFilters}
                  />
                </li>
              </ul>
            </nav>
          </div>
        )}
        {filterByCohort && <CreateCohort onReportProcess={toggleDropdown} />}
      </div>
    </Fragment>
  );
};

function mapStateToProps(state) {
  return {
    sideNavToggle: state.Page.sideNavToggle,
    reportLink: state.Page.reportLink.reportUrl,
    linkName: state.Page.reportLink.reportDisplayName,
    userPersonated: state.Impersonate.impersonate.userPersonated,
    cohorts: state.Cohort.cohorts,
    reportLinkObj: state.Page.reportLink,
    casDetails: state.AppSession.activeCasDetails,
    institutionDetails: state.AppSession.institutionDetails,
    workSheetName: state.Page.reportLink.exportWorkSheetName,
    reportMenus: state.Page.reportMenus,
    loggedUserDetails: state.AppSession.userDetails,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getReportLink,
      getCohorts,
      getCohortsOrganizations,
      triggerNavFocus,
      getReportMenu,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(withNavigate(Reports));
